module.exports = __webpack_public_path__ + "static/media/Pradaxa.ae46859e.jpg";